import { render, staticRenderFns } from "./auditevents-list.vue?vue&type=template&id=68cc1f32&"
import script from "./auditevents-list.vue?vue&type=script&lang=js&"
export * from "./auditevents-list.vue?vue&type=script&lang=js&"
import style0 from "./auditevents-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports